import { FormEvent } from "react";
import clsx from "clsx";

import { NEIGHBOUR_PAGES } from "@utils/index";
import {
  ButtonPage,
  FormInput,
  ChevronLeftSvg,
  ChevronRightSvg,
} from "@components/index";

export const Pagination = ({
  count,
  perPage,
  currentPage,
  onSelect,
  className = "",
}: {
  count: number;
  perPage: number;
  currentPage: number;
  onSelect: (page: number) => void;
  className?: string;
}) => {
  const lastPage = Math.ceil(count / perPage);
  if (currentPage > lastPage) {
    currentPage = lastPage;
  }
  const leftPagesCount = currentPage - 1;
  const rightPagesCount = lastPage - currentPage;

  const leftPages = Array(leftPagesCount)
    .fill(0)
    .map((_, index) => 1 + index)
    .slice(1);
  const rightPages = Array(rightPagesCount)
    .fill(0)
    .map((_, index) => currentPage + 1 + index)
    .slice(0, -1);

  const onChange = ({ currentTarget }: FormEvent<HTMLInputElement>) => {
    const value = parseInt(currentTarget.value || "1", 10);
    onSelect(value < 1 ? 1 : value > lastPage ? lastPage : value);
  };

  return (
    <div className="flex items-center gap-x-1 md:gap-x-4">
      <div
        className={clsx(
          "flex items-center gap-x-4 text-300 text-black-54",
          className,
        )}
      >
        <ButtonPage
          disabled={currentPage <= 1}
          icon={<ChevronLeftSvg />}
          currentPage={currentPage}
          onClick={() => onSelect(currentPage - 1)}
        />
        <ButtonPage
          page={1}
          currentPage={currentPage}
          onClick={() => onSelect(1)}
        />

        {leftPages.length > NEIGHBOUR_PAGES && "..."}
        {leftPages.slice(-NEIGHBOUR_PAGES).map((page) => (
          <ButtonPage
            key={page}
            page={page}
            currentPage={currentPage}
            onClick={() => onSelect(page)}
          />
        ))}

        {currentPage !== 1 && currentPage !== lastPage && (
          <ButtonPage
            page={currentPage}
            currentPage={currentPage}
            onClick={() => onSelect(currentPage)}
          />
        )}

        {rightPages.slice(0, NEIGHBOUR_PAGES).map((page) => (
          <ButtonPage
            key={page}
            page={page}
            currentPage={currentPage}
            onClick={() => onSelect(page)}
          />
        ))}
        {rightPages.length > NEIGHBOUR_PAGES && "..."}

        {lastPage > 1 && (
          <ButtonPage
            page={lastPage}
            currentPage={currentPage}
            onClick={() => onSelect(lastPage)}
          />
        )}
        <ButtonPage
          disabled={currentPage >= lastPage}
          icon={<ChevronRightSvg />}
          currentPage={currentPage}
          onClick={() => onSelect(currentPage + 1)}
        />
      </div>
      <div className="ml-4 text-300 text-black-54">Go to</div>
      <div className="w-20">
        <FormInput
          type="number"
          name="page"
          label=""
          height="small"
          value={currentPage}
          onChange={onChange}
        />
      </div>
    </div>
  );
};
